module.exports = __webpack_public_path__ + "static/media/Tita-oval.77eb9cc1.jpg";